import { Ico84Check } from "@/shared/assets/icons/ico_84_check";
import { Button } from "@/shared/ui/button";
import { useTranslations } from "next-intl";

interface SuccessStepProps {
  title: string;
  description?: string;
  button1: {
    label: string;
    onClick: () => void;
  };
  button2: {
    label: string;
    onClick: () => void;
  };
}
export function SuccessStep({ title, description, button1, button2 }: SuccessStepProps) {
  const t = useTranslations();
  return (
    <div className="flex w-full flex-col items-center text-center">
      <div className="bg-primary-100 tb:h-21 tb:w-21 tb:mb-12 mb-6 flex h-14 w-14 items-center justify-center rounded-full">
        <Ico84Check />
      </div>
      <div className="mb-10">
        <h3 className="heading-3-bold tb:mb-3 mb-2 text-gray-900">{title}</h3>
        {description && (
          <p
            className="tb:whitespace-normal body-md-regular whitespace-pre-line text-gray-900"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>

      <div className="tb:flex-row tb:gap-4 tb:max-w-[420px] tb:gap-3 flex w-full flex-col justify-center gap-2">
        <Button type="button" className="tb:flex-1 w-full" variant="line" size="lg" onClick={button1.onClick}>
          {t(button1.label)}
        </Button>
        <Button type="button" className="tb:flex-1 w-full" variant="primary" size="lg" onClick={button2.onClick}>
          {t(button2.label)}
        </Button>
      </div>
    </div>
  );
}
